(ns frontend.ui.page.lp-report-editor.step-3-review.sub
  (:require
   [frontend.ui.page.lp-report-editor.sub :as editor-sub]))

(def report-tab-path (conj editor-sub/editor-path :review-report-tab))